import { isAfter } from 'date-fns';

import { ExpectedRespondent } from '../models/ParticipantEvent';
import { StudyParticipant } from '../models/StudyParticipant';

export type LarTaskRole = 'lar' | 'teen';

type ExpectedRespondentEvent = {
  expectedRespondent?: ExpectedRespondent | null;
};

export function canCompleteEvent(
  role: LarTaskRole,
  event?: ExpectedRespondentEvent
) {
  const respondent = event?.expectedRespondent;
  if (role === 'lar') {
    if (!respondent) {
      return true;
    }
    return (
      respondent === ExpectedRespondent.Proxy ||
      respondent === ExpectedRespondent.Flexible
    );
  }
  return (
    respondent === ExpectedRespondent.SelfReport ||
    respondent === ExpectedRespondent.Flexible
  );
}

export function isStatusOnlyEvent(
  role: LarTaskRole,
  event?: ExpectedRespondentEvent
) {
  const respondent = event?.expectedRespondent;
  if (role === 'lar') {
    return respondent === ExpectedRespondent.SelfReport;
  }
  return respondent === ExpectedRespondent.Proxy;
}

export function todayItemPresentation(
  role: LarTaskRole,
  event: ExpectedRespondentEvent | undefined,
  status: string,
  selectedDate: Date,
  study?: { status?: string }
) {
  const completable = canCompleteEvent(role, event);
  const respondent = event?.expectedRespondent;
  const respondentLabel =
    role === 'lar' && respondent === ExpectedRespondent.SelfReport
      ? 'Participant Only'
      : role === 'teen' && respondent === ExpectedRespondent.Proxy
        ? 'Caregiver Only'
        : undefined;
  const studyClosed =
    study?.status === 'Locked' || study?.status === 'Completed';
  const selectedInFuture = isAfter(selectedDate, new Date());
  const actionable =
    completable &&
    (status === 'persistent' ||
      ((status === 'past' || status === 'expiringSoon') && !studyClosed));
  const disabled =
    !completable ||
    (status === 'persistent' && selectedInFuture) ||
    status === 'completed' ||
    status === 'expired' ||
    status === 'future' ||
    selectedInFuture ||
    studyClosed;
  return {
    completable,
    statusOnly: isStatusOnlyEvent(role, event),
    respondentLabel,
    actionable,
    disabled,
    opacity: actionable ? 1 : 0.7
  };
}

export function pediatricSubjectName(studyParticipant: StudyParticipant) {
  return [studyParticipant.user?.firstName, studyParticipant.user?.lastName]
    .filter(Boolean)
    .join(' ')
    .trim();
}

export function pediatricEnrollmentLabel(studyParticipant: StudyParticipant) {
  const name = pediatricSubjectName(studyParticipant);
  const studyName = studyParticipant.study?.name || 'Study';
  return name ? `${name} · ${studyName}` : studyName;
}
